import { styled } from '@withjoy/joykit';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledContainer = styled(Flex)<{ hasError?: boolean }>`
  padding: ${props => props.theme.space[4]} ${props => props.theme.space[5]};
  border: 1px solid ${props => props.theme.colors.mono5};
  align-items: center;
  width: 100%;
  max-width: ${() => pxToRem(128)};
  overflow: hidden;
  border-radius: ${props => props.theme.radii[3]};
  ${props => props.hasError && `border-color: ${props.theme.colors.red3}`};
  /* The composite owns the field's chrome -- StyledInput is borderless and outline-less by design,
     so this wrapper is the only focus indicator the control has. It was drawing 1px where the
     contract draws 2px. Kept as a 1px border plus a 1px inset shadow rather than a 2px border: the
     container has a fixed 128px max-width and 'overflow: hidden', so growing the border would move
     the text inside it. Same device the shipping dialog's phone field uses (see PLAN.md phase 3). */
  &:focus-within {
    border-color: ${props => props.theme.colors.mono14};
    box-shadow: inset 0 0 0 1px ${props => props.theme.colors.mono14};
  }
`;

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`;

// Borderless by design; StyledContainer above owns this field's focus chrome, which is why the
// input itself draws none. Recorded in EXCEPTIONS.md.
// eslint-disable-next-line no-restricted-syntax -- composite owns the chrome, see above
export const StyledInput = styled.input`
  font: inherit;
  padding: 4px;
  border: none;
  min-width: 1ch;
  width: auto;
  outline: none;
  color: ${props => props.theme.colors.mono14};
`;

export const Mirror = styled.span`
  position: absolute;
  visibility: hidden;
  white-space: pre;
  font: inherit;
  padding: 4px;
`;
